<template>
  <div class="header">
    <parallax :speed-factor="0.2" direction="up">
      <img src="../assets/background1.jpg" alt="Ilir Latifi" />
      <div class="header__overlay"></div>
    </parallax>
    <div class="header__content">
      <span class="header__heading-span">"THE SLEDGEHAMMER"</span>
      <h1 class="header__heading">ILIR LATIFI</h1>
      <span class="header__division"
        >#12 Light Heavyweight Division 15-7-0 (W-L-D)</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Header"
};
</script>

<style lang="scss" scoped>
.header {
  margin-bottom: 4rem;
  &__content {
    position: absolute;
    top: 100px;
    right: 20px;
    color: white;
  }
  &__overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0.7;
    transition: 0.5s ease;
    background-color: rgb(11, 10, 10);
    overflow: hidden;
  }
  &__content {
    @media (min-width: 1024px) {
      top: 40%;
      left: 50%;
      transform: translate(-50%, 50%);
    }
    position: absolute;
    top: 30%;
  }

  &__heading,
  &__heading-span {
    font-family: "Sigmar One", cursive, sans-serif;
  }

  &__heading {
    font-size: 2rem;
    @media (min-width: 1024px) {
      font-size: 6rem;
    }
  }

  &__heading-span {
    font-size: 1.5rem;
  }

  &__division {
    font-size: 1.5rem;
    font-family: "Inconsolata", monospace;
  }
}
</style>
